import classnames from 'classnames';
import { StoredUser } from 'store/features/authentication';
import { Device } from 'types';
import { useUi } from 'hooks/useUi';
import DeviceInformationMainCard from './cards/DeviceInformationMainCard/DeviceInformationMainCard';
import DeviceInformationGraphCard from './cards/DeviceInformationGraphCard/DeviceInformationGraphCard';
import styles from './DeviceInformation.module.scss';

export interface DeviceInformationProps {
    device: Device;
    user: StoredUser | null;
}

export function DeviceInformation({ device, user }: DeviceInformationProps) {
    const { ui } = useUi();

    return (
        <div
            className={classnames(
                styles.DeviceInformation,
                ui.isMobile ? styles.isMobile : ''
            )}
            data-testid="device-information"
        >
            <DeviceInformationMainCard device={device} user={user} />
            <div className={styles.usageGraph}>
                <DeviceInformationGraphCard device={device} />
            </div>
        </div>
    );
}
